import { useNavigate } from 'react-router-dom';

const comparisonData = [
  {
    feature: 'Product Discovery',
    basetao: 'Organized spreadsheet with curated links by category',
    traditional: 'Manual browsing without structured organization',
  },
  {
    feature: 'Price Research',
    basetao: 'Side-by-side price comparisons across similar products',
    traditional: 'Individual product searches with no comparison view',
  },
  {
    feature: 'Quality Information',
    basetao: 'Community-verified quality checks and detailed reviews',
    traditional: 'Limited quality data, rely on seller descriptions',
  },
  {
    feature: 'Shipping Knowledge',
    basetao: 'Consolidated shipping cost guides and delivery estimates',
    traditional: 'Calculate shipping costs independently per item',
  },
  {
    feature: 'Community Resources',
    basetao: 'Shared finds, tips, and collective shopping intelligence',
    traditional: 'Solo shopping with no community input or validation',
  },
];

export default function Comparison() {
  const navigate = useNavigate();

  return (
    <section className="py-16 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="text-2xl md:text-3xl font-heading font-semibold text-foreground-900 mb-3">
            Basetao Spreadsheet vs Traditional Shopping
          </h2>
          <p className="text-sm md:text-base text-foreground-500 max-w-2xl mx-auto">
            See how using organized Basetao Spreadsheet resources transforms your shopping experience compared to browsing without structured tools.
          </p>
        </div>

        <div className="bg-background-50 rounded-lg overflow-hidden">
          <div className="overflow-x-auto">
            <table className="w-full">
              <thead>
                <tr className="border-b border-background-200/70">
                  <th className="text-left px-5 py-4 text-xs font-semibold text-foreground-500 uppercase tracking-wider">Feature</th>
                  <th className="text-left px-5 py-4 text-xs font-semibold text-primary-600 uppercase tracking-wider">Basetao Spreadsheet</th>
                  <th className="text-left px-5 py-4 text-xs font-semibold text-foreground-500 uppercase tracking-wider">Traditional Shopping</th>
                </tr>
              </thead>
              <tbody>
                {comparisonData.map((row, idx) => (
                  <tr key={row.feature} className={`border-b border-background-200/40 ${idx % 2 === 0 ? 'bg-background-50' : 'bg-background-100/50'}`}>
                    <td className="px-5 py-4 text-sm font-medium text-foreground-800 whitespace-nowrap">{row.feature}</td>
                    <td className="px-5 py-4 text-sm text-foreground-600">
                      <span className="flex items-start gap-2">
                        <i className="ri-check-line text-primary-500 mt-0.5 flex-shrink-0"></i>
                        {row.basetao}
                      </span>
                    </td>
                    <td className="px-5 py-4 text-sm text-foreground-400">
                      <span className="flex items-start gap-2">
                        <i className="ri-close-line text-foreground-300 mt-0.5 flex-shrink-0"></i>
                        {row.traditional}
                      </span>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>

        <div className="text-center mt-8">
          <button
            onClick={() => navigate('/basetao-spreadsheet-guide')}
            className="inline-flex items-center gap-2 text-sm font-medium text-primary-600 hover:text-primary-700 transition-colors duration-200 cursor-pointer"
          >
            See detailed comparison in our full guide
            <i className="ri-arrow-right-line"></i>
          </button>
        </div>
      </div>
    </section>
  );
}